'use client';

import { jsxs, jsx } from "react/jsx-runtime";
import { classNames } from "../../utils/styles/classNames.js";
import { Text } from "../../atoms/Text/Text.js";
import { textColorValues } from "../../atomic/colors.css.js";
import { hasContrast } from "../../themes/utils/hasContrast.js";
import { getInitials } from "./utils.js";
import { sizeVariants, avatarImg, avatar } from "./Avatar.css.js";
import { sizeToFontVariant } from "./constants.js";
function Avatar({
  alt,
  backgroundColor,
  className,
  size = "sm",
  name,
  src,
  srcSet
}) {
  const initials = getInitials(name);
  const initialsColor = backgroundColor && hasContrast(backgroundColor, textColorValues["onLight.text.primary"]) ? "onLight.text.primary" : "onDark.text.primary";
  const color = initialsColor;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(avatar, sizeVariants[size], className),
      style: {
        backgroundColor
      },
      children: [
        src && /* @__PURE__ */ jsx(
          "img",
          {
            alt: alt || "",
            className: classNames(avatarImg, sizeVariants[size]),
            src,
            srcSet
          }
        ),
        initials && !src && /* @__PURE__ */ jsx(Text, { color, variant: sizeToFontVariant[size], children: initials })
      ]
    }
  );
}
export {
  Avatar
};
